import { ThemeColors } from '@lyrahealth-inc/shared-app-logic'

import { getFocusBoxShadow } from '../../../styles'

export enum SelectStyleType {
  DEFAULT = 'default',
  LEGACY = 'legacy',
  TRIAGE = 'triage',
}

export const getSelectStyles = (colors: ThemeColors, isFocused: boolean) => ({
  [SelectStyleType.DEFAULT]: {
    select: {
      height: 48,
      paddingRight: 48,
    },
    iconContainer: {
      right: 16,
    },
    icon: {
      size: 16,
    },
  },
  [SelectStyleType.TRIAGE]: {
    select: {
      paddingLeft: 23,
      paddingRight: 48,
      borderRadius: 100,
      height: 56,
      borderColor: colors.inputOutlineTriageDefault,
      backgroundColor: colors.inputBackgroundTriageDefault,
      borderWidth: 1,
      ...(isFocused && getFocusBoxShadow({ colors })),
    },
    iconContainer: {
      right: 24,
    },
    icon: {
      size: 24,
    },
  },
})
